/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineExtraStayDetailsDto
 */
export interface TravelineExtraStayDetailsDto {
    /**
     * Date and property local time<br />
     * Date and time format complies with ISO-8601 YYYY-MM-DDThh:mm
     * @type {Date}
     * @memberof TravelineExtraStayDetailsDto
     */
    overriddenDateTime: Date;
}

/**
 * Check if a given object implements the TravelineExtraStayDetailsDto interface.
 */
export function instanceOfTravelineExtraStayDetailsDto(value: object): value is TravelineExtraStayDetailsDto {
    if (!('overriddenDateTime' in value) || value['overriddenDateTime'] === undefined) return false;
    return true;
}

export function TravelineExtraStayDetailsDtoFromJSON(json: any): TravelineExtraStayDetailsDto {
    return TravelineExtraStayDetailsDtoFromJSONTyped(json, false);
}

export function TravelineExtraStayDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineExtraStayDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'overriddenDateTime': (new Date(json['overriddenDateTime'])),
    };
}

  export function TravelineExtraStayDetailsDtoToJSON(json: any): TravelineExtraStayDetailsDto {
      return TravelineExtraStayDetailsDtoToJSONTyped(json, false);
  }

  export function TravelineExtraStayDetailsDtoToJSONTyped(value?: TravelineExtraStayDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overriddenDateTime': ((value['overriddenDateTime']).toISOString()),
    };
}

